import { Injectable } from '@angular/core';
import {
 HttpEvent,
 HttpInterceptor,
 HttpHandler,
 HttpRequest,
 HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthServiceInterface } from './auth.interface';
import { AUTH_SERVICE } from './token';
import { Inject } from '@angular/core';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {

 constructor(@Inject(AUTH_SERVICE) private authService: AuthServiceInterface) {}

 intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
   return next.handle(req).pipe(
     catchError((error: HttpErrorResponse) => {
       if (error.status === 401) {
         console.error('[AuthErrorInterceptor] Received 401 Unauthorized. Redirecting to login.');
         this.authService.logout();
         return new Observable<HttpEvent<unknown>>();
       }
       return throwError(() => error);
     })
   );
 }
}
